import React from 'react';

const GreetingBanner = ({ userName, phaseName }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  return (
    <div
      className="flex flex-col md:flex-row justify-between items-center rounded-xl md:rounded-2xl p-6 px-4 md:p-5 md:px-8 mt-4 md:mt-0 mb-4 md:mb-6 overflow-hidden relative mx-4 md:mx-0 shadow-[0_2px_8px_rgba(0,0,0,0.1)] md:shadow-[var(--shadow-sm)] bg-gradient-to-r from-[#1d4746] via-[#236463] to-[#12766d] dark:from-[#0f2928] dark:via-[#153938] dark:to-[#0d4f49]"
    >
      <div className="flex-1 text-white z-10 w-full md:w-auto p-0 m-0 text-center md:text-left">
        <img
          src="/ZenVokus-New/Logo ZenVOKUS (White).png"
          alt="ZenVokus Logo"
          className="w-[50px] md:w-[120px] h-auto block mx-auto md:mx-0 mb-2.5 md:mb-0"
        />
        <h1 className="text-lg md:text-3xl font-bold text-white leading-tight mb-1.5 md:-mt-3.5 md:mb-0.5">
          {getGreeting()}, <span className="text-accent-yellow">{userName || 'Learner'}!</span>
        </h1>
        <p className="text-xs md:text-base text-white/90 mb-2.5 md:mb-4">
          Ready to continue your learning journey?
        </p>
      </div>
      <div className="flex-shrink-0 w-[100px] h-[100px] md:w-[150px] md:h-[150px] flex items-center justify-center mt-3 md:mt-0">
        <img
          src="/DashboardAsset/Books.png"
          alt="Learning illustration"
          className="w-full h-full object-contain drop-shadow-lg"
        />
      </div>
    </div>
  );
};

export default GreetingBanner;
